import { OsaWay } from "../../osaway/models/OsaWay";
import { QueryPolygon } from "../../ra/models/QueryPolygon";
import { HlaWay } from "../../ra/models/HlaWay";
import { OptionalScope } from "../../shared/models/OptionalScope";
import { Page } from "../../shared/utils/http-utils";
import {
  jwtAuthAxios,
  optionalAuthAxios,
} from "../../shared/utils/network-utils";
import {
  Campaign,
  CreateCampaignRequest,
  UpdateCampaignRequest,
} from "../models/Campaign";

const prefix = "/campaigns";

export const CampaignApi = {
  get: async (id: string) =>
    await optionalAuthAxios().get<Campaign>(`${prefix}/${id}`),

  create: async (body: CreateCampaignRequest) => {
    return await jwtAuthAxios().post<Campaign>(`${prefix}`, body);
  },

  update: async (id: string, body: UpdateCampaignRequest) => {
    return await jwtAuthAxios().put<Campaign>(`${prefix}/${id}`, body);
  },

  delete: async (id: string) => {
    return await jwtAuthAxios().delete(`${prefix}/${id}`);
  },

  pageOsaWays: async (
    campaignId: string,
    scopes: OptionalScope[] = [],
    pageSize: number,
    pageNumber: number
  ) =>
    await optionalAuthAxios().get<Page<OsaWay>>(
      `${prefix}/${campaignId}/osa-ways`,
      {
        params: {
          "page[size]": pageSize,
          "page[number]": pageNumber,
          scopes: scopes.join(),
        },
      }
    ),

  pageHlaWays: async (
    campaignId: string,
    pageSize: number,
    pageNumber: number
  ) =>
    await optionalAuthAxios().get<Page<HlaWay>>(
      `${prefix}/${campaignId}/hla-ways`,
      {
        params: {
          "page[size]": pageSize,
          "page[number]": pageNumber,
        },
      }
    ),

  queryPolygon: async (id: string, body: QueryPolygon) =>
    await jwtAuthAxios().post<string>(`${prefix}/${id}/query-polygon`, body),
};
